import { ReactElement } from "react";
import Text from "@ui-kit/typography/Text/Text.web";
import type { HighlightMatchingTextSharedProps } from "./HighlightMatchingText.props";

export default function HighlightMatchingText({
  text,
  matchingText,
}: HighlightMatchingTextProps): ReactElement {
  const index = text.toLowerCase().indexOf(matchingText.toLowerCase());
  if (index === -1) {
    return <>{text}</>;
  }
  const firstPart = text.slice(0, index);
  const matchingPart = text.slice(index, index + matchingText.length);
  const lastPart = text.slice(index + matchingText.length);
  return (
    <>
      {firstPart}
      <Text as="span" fontWeight="bold">
        {matchingPart}
      </Text>
      {lastPart}
    </>
  );
}

export type HighlightMatchingTextProps = HighlightMatchingTextSharedProps & {
  // Add any web specific props here.
};
